import Button from 'react-bootstrap/Button'
import Dropdown from 'react-bootstrap/Dropdown'
import { Box, Checkbox, ListItemText, MenuItem, Select, Typography } from '@mui/material';
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Utils from '../../constants/Utils'
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { uplodateLoading } from '../../../redux/features/common/commonSlice';
import urls from '../../constants/apiurl';
import ApiCaller from '../../constants/ApiCaller';
import { showDangerToast, showToast } from '../../constants/toaster';
export const EditVideo = props => {
    const [contentTypeDropdownText, setContentTypeDropdownText] = useState({})
    const [videoDetails, setVideoDetails] = useState({})
    const userData = useSelector((state) => state?.userData);
    const adminUserNameHeader =
        userData?.email || userData?.emailId || userData?.userName || ''
    const videoApiHeaders = adminUserNameHeader
        ? { userName: adminUserNameHeader }
        : {}
    const dispatch = useDispatch();
    const [selectedCategoryValues, setSelectedCategoryValues] = useState([]);
    const [categoryLabel, setCategoryLabel] = useState('Select Category')
    const [selectedLanguageValues, setSelectedLanguageValues] = useState([]);
    const [categoryDataList, setCategoryDataList] = useState([])
    const [categoryDataCompleteList, setCategoryDataCompleteList] = useState([])
    const [languageDataList, setLanguageDataList] = useState([])
    const [languageDataCompleteList, setLanguageDataCompleteList] = useState([])
    const handleChange = (event, type) => {
        if (type === 0) {
            setSelectedCategoryValues(event.target.value);
        } else if (type === 1) {
            setSelectedLanguageValues(event.target.value);
        }
    };

    const onSubmit = async () => {
        let tempCategoryArray = [];
        let tempLanguageArray = [];

        if (selectedCategoryValues?.length && categoryDataCompleteList?.length) {
            const selectedCategorySet = new Set([...selectedCategoryValues]); // Convert to Set for O(1) lookup.
            tempCategoryArray = categoryDataCompleteList
                .filter(item => selectedCategorySet.has(item?.key)) // Filter items with matching keys.
                .map(item => item?.value); // Extract their values.
        }
        if (selectedLanguageValues?.length && languageDataCompleteList?.length) {
            const selectedLanguageSet = new Set([...selectedLanguageValues]); // Convert to Set for O(1) lookup.
            tempLanguageArray = languageDataCompleteList
                .filter(item => selectedLanguageSet.has(item?.value)) // Filter items with matching keys.
                .map(item => item?.key); // Extract their values.
        }
        let postJson = {
            id: videoDetails?.id,
            categoryIds: tempCategoryArray,
            languageIds: tempLanguageArray,
            videoContentType: contentTypeDropdownText?.id
        }
        console.log(postJson)
        try {
            dispatch(uplodateLoading(true))
            let path = urls.updateVideo
            let res = await ApiCaller.post(
                postJson,
                path,
                userData?.access_token,
                videoApiHeaders
            )
            const response = await res.response.json()
            console.log('res', response)
            dispatch(uplodateLoading(false))
            if (response?.status == 200 || response?.successful === true) {
                showToast(response?.message)
                props?.onHide()
            } else {
                showDangerToast(response.message)
            }
            props?.getVideoList()
        } catch (error) {
            dispatch(uplodateLoading(false))
            console.error(error)
            showDangerToast(error.message)
            return false
        }
    }


    const getCategoryFilterData = async () => {
        try {
            dispatch(uplodateLoading(true));
            let path = urls.tagInterestListKeyValuePair + "?keyword=";
            let res = await ApiCaller.get({}, path, userData?.access_token);
            const response = await res.response.json();
            if (response?.status == 200 || response?.successful === true) {
                dispatch(uplodateLoading(false));
                dispatch(uplodateLoading(false))
                let tempArray = []
                for (let i = 0; i < response?.data?.length; i++) {
                    tempArray.push(response?.data?.[i]?.key)
                }
                setCategoryDataList(tempArray)
                setCategoryDataCompleteList(response?.data)
                setVideoDetails(props?.selectedVideoDetails)
                let tempSelectedVideos = [];
                for (let i = 0; i < props?.selectedVideoDetails?.categoryList?.length; i++) {
                    for (let j = 0; j < tempArray?.length; j++) {
                        if (tempArray[j] === props?.selectedVideoDetails?.categoryList[i]) {
                            tempSelectedVideos.push(tempArray[j])
                        }
                    }
                }
                setSelectedCategoryValues([...tempSelectedVideos])
            } else {
                dispatch(uplodateLoading(false));
                showDangerToast(response.message);
            }
        } catch (error) {
            dispatch(uplodateLoading(false));
            console.error(error);
            showDangerToast(error.message);
        }
    }
    //console.log("props?.selectedVideoDetails?.videoContentType::::::::::::::::::::::::::::::::::", props?.selectedVideoDetails?.videoContentType)
    

    useEffect(() => {
        if (props?.show) {
            getCategoryFilterData()
            getLanguageFilterData()
            if (props?.selectedVideoDetails?.videoContentType) {
                if (props?.selectedVideoDetails?.videoContentType === 'EVERYONE') {
                    setContentTypeDropdownText({
                        id: 'EVERYONE',
                        label: 'Everyone'
                    })
                } else if (props?.selectedVideoDetails?.videoContentType === 'EIGHTEEN_PLUS') {
                    setContentTypeDropdownText({
                        id: 'EIGHTEEN_PLUS',
                        label: '18+'
                    })
                } else if (props?.selectedVideoDetails?.videoContentType === 'BELOW_EIGHTEEN') {
                    setContentTypeDropdownText({
                        id: 'BELOW_EIGHTEEN',
                        label: 'Below 18'
                    })
                }
            }
        }
    }, [props?.show])

    const getLanguageFilterData = async () => {
        try {
            dispatch(uplodateLoading(true));
            let path = urls.languageListKeyValuePair + "?keyword=";
            let res = await ApiCaller.get({}, path, userData?.access_token);
            const response = await res.response.json();
            if (response?.status == 200 || response?.successful === true) {
                dispatch(uplodateLoading(false));
                let tempArray = []
                for (let i = 0; i < response?.data?.length; i++) {
                    tempArray.push(response?.data?.[i]?.value)
                }
                setLanguageDataList(tempArray)
                setLanguageDataCompleteList(response?.data)
                setVideoDetails(props?.selectedVideoDetails)
                let tempSelectedVideos = [];
                for (let i = 0; i < props?.selectedVideoDetails?.languageList?.length; i++) {
                    for (let j = 0; j < tempArray?.length; j++) {
                        if (tempArray[j] === props?.selectedVideoDetails?.languageList[i]) {
                            tempSelectedVideos.push(tempArray[j])
                        }
                    }
                }
                setSelectedLanguageValues([...tempSelectedVideos])
            } else {
                dispatch(uplodateLoading(false));
                showDangerToast(response.message);
            }
        } catch (error) {
            dispatch(uplodateLoading(false));
            console.error(error);
            showDangerToast(error.message);
        }
    }

    const { formatDate } = Utils();
    return (
        <Modal
            {...props}
            size='lg'
            aria-labelledby='contained-modal-title-vcenter'
            centered
        >
            <Modal.Body>
                <div className='row'>
                    <h3 className='col-md-12 text-center'>Edit Video Category/Language</h3>
                </div>
                <hr />
                <div className='row mt-5'>
                    <div className='col-md-6'>
                        <Form.Group controlId='exampleForm.ControlInput1'>
                            <div style={{ display: 'grid' }}>
                                <Form.Label>Select Category</Form.Label>
                                <Select
                                    multiple
                                    value={selectedCategoryValues}
                                    onChange={(e) => handleChange(e, 0)}
                                    renderValue={(selected) => `${selected.length} Selected`} // Display count of selected items
                                    label={categoryLabel}
                                >
                                    {categoryDataList.map((option) => (
                                        <MenuItem key={option} value={option}>
                                            <Checkbox checked={selectedCategoryValues.indexOf(option) > -1} />
                                            <ListItemText primary={option} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </div>
                        </Form.Group>
                    </div>
                    <div className='col-md-6'>
                        <Form.Group controlId='exampleForm.ControlInput1'>
                            <div style={{ display: 'grid' }}>
                                <Form.Label>Select Language</Form.Label>
                                <Select
                                    multiple
                                    value={selectedLanguageValues}
                                    onChange={(e) => handleChange(e, 1)}
                                    renderValue={(selected) => `${selected.length} Selected`} // Display count of selected items
                                    label={categoryLabel}
                                >
                                    {languageDataList.map((option) => (
                                        <MenuItem key={option} value={option}>
                                            <Checkbox checked={selectedLanguageValues.indexOf(option) > -1} />
                                            <ListItemText primary={option} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </div>
                        </Form.Group>
                    </div>
                    <div className='col-md-6 mt-2'>
                        <Form.Group controlId='exampleForm.ControlInput1'>
                            <div style={{ display: 'grid' }}>
                                <Form.Label>Select Age Group</Form.Label>
                                <Dropdown>
                                    <Dropdown.Toggle
                                        variant='success'
                                        style={{
                                            backgroundColor: 'white',
                                            color: 'black',
                                            border: '1px solid #cad1d7',
                                            boxShadow: 'none',
                                            transform: 'none'
                                        }}
                                        id='dropdown-basic'
                                    >
                                        {contentTypeDropdownText?.label}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item
                                            onClick={() => {
                                                setContentTypeDropdownText({
                                                    id: 'EVERYONE',
                                                    label: 'Everyone'
                                                })
                                            }
                                            }
                                        >
                                            Everyone
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            onClick={() => {
                                                setContentTypeDropdownText({
                                                    id: 'EIGHTEEN_PLUS',
                                                    label: '18+'
                                                })
                                            }
                                            }
                                        >
                                            18+
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            onClick={() => {
                                                setContentTypeDropdownText({
                                                    id: 'BELOW_EIGHTEEN',
                                                    label: 'Below 18'
                                                })
                                            }
                                            }
                                        >
                                            Below 18
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </Form.Group>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='outlined' onClick={() => onSubmit()}>
                    Submit
                </Button>
                <Button variant='outlined' onClick={props.onHide}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
